export default __webpack_public_path__ + "images/6edab323f4612c8ddb0c17d1ba1a9784.svg";